import React from "react";
import { FormularioPerfil } from "../../components/Vecino/FormularioPerfil";

export const CompletarPerfil = () => {
  return (
    <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header my-5">
              <div className="card-title mt-5">
                <h1 className="text-gray-700 mb-md-5">Completar registro</h1>
              </div>
            </div>
            <div className="card-body pt-0">
              <FormularioPerfil modo="primer_registro"></FormularioPerfil>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
